import { useHasCompanyPermission } from "@/shared/hooks/use-has-permission";
import { useGetControlResultAttachments } from "@/spz-api/control-result-comments/control-result-comments";
import { useGetMe } from "@/spz-api/user/user";
import { CompanyPermission } from "@spz/shared-domain";
import { Badge } from "@spz/ui/components/badge";
import { useTranslation } from "react-i18next";
import { ResultDetailActivityListing } from "../components/details-activity-listing/result-detail-activity-listing";
import { ResultDetailAttachmentsListing } from "../components/details-activity-listing/result-detail-attachment-listing";
import { ResultDetailActivityForm } from "../forms/result-detail-activity-form";

export const useResultDetailActivityTabViewModel = ({
  controlId,
  companyId,
  controlResultId,
}: {
  controlId: string;
  companyId: string;
  controlResultId: string;
}) => {
  const { t } = useTranslation();
  const { data: user } = useGetMe();

  const canWriteCommentsAndAttachments =
    useHasCompanyPermission(
      CompanyPermission.ControlResultSkip,
      user,
      companyId,
    ) ||
    useHasCompanyPermission(
      CompanyPermission.ControlResultStartInvestigation,
      user,
      companyId,
    ) ||
    useHasCompanyPermission(
      CompanyPermission.ControlResultCompleteInvestigation,
      user,
      companyId,
    );

  const { data: attachmentList, isLoading } = useGetControlResultAttachments(
    controlId,
    controlResultId,
  );
  const tabs = [
    {
      value: "activity",
      label: t("activity"),
      testId: "control-section-activity",
      component: (
        <div className="flex flex-col h-full space-y-4">
          {canWriteCommentsAndAttachments && (
            <ResultDetailActivityForm
              controlId={controlId}
              controlResultId={controlResultId}
              companyId={companyId}
            />
          )}
          <ResultDetailActivityListing
            controlId={controlId}
            controlResultId={controlResultId}
            canWriteCommentsAndAttachments={canWriteCommentsAndAttachments}
          />
        </div>
      ),
    },
    {
      value: "attachments",
      label: (
        <div className="flex items-center gap-2">
          {t("attachments")}
          {(attachmentList?.data?.length ?? 0) > 0 ? (
            <Badge variant="filled" className="w-4 h-5">
              {attachmentList?.data?.length ?? 0}
            </Badge>
          ) : null}
        </div>
      ),
      testId: "control-section-attachments",
      component: (
        <ResultDetailAttachmentsListing
          controlId={controlId}
          controlResultId={controlResultId}
          isLoading={isLoading}
          data={attachmentList?.data ?? []}
        />
      ),
    },
  ];

  return { tabs };
};
